import GlobeSvg from 'components/svg/GlobeSvg';
import ToggleArrowSvg from 'components/svg/ToggleArrowSvg';
import P from 'components/ui/P';
import { useLocale } from 'shared/hooks/i18n';
import { FC } from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';

interface Props {
  onClick: () => void;
  isOpen: boolean;
  className?: string;
}

const Toggle: FC<Props> = ({ onClick, className, isOpen }) => {
  const lang = useLocale();

  return (
    <div className={classNames(styles.languageSelector, className)} onClick={onClick}>
      <div className={styles.content}>
        <div className={styles.svg}>
          <GlobeSvg />
        </div>
        <P>{lang.toUpperCase()}</P>
        <ToggleArrowSvg isActive={isOpen} />
      </div>
    </div>
  );
};

export default Toggle;
